import React, { useState } from 'react';
import {
    Accordion,
    AccordionDetails,
    Grid,
    Link,
    Tooltip,
    Typography
} from '@material-ui/core';
import moment from 'moment';
import { downloadPDF, FlippedOrderExpansionPanelSummary } from '../../utils/functionsUtils';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { headers } from './headers';
import VisibilityIcon from "@material-ui/icons/Visibility";
import CarnetIcon from "@material-ui/icons/PlaylistAddCheck";
import { styleCertificate } from './styleCertificate';
import { downloadCertificate, getCertificateId } from '../../actions/employee-action';
import GenerateCertificate from './createCerticate/modalGenerateCertificate';

const AccordionCertificate = ({
    data,
    maestras,
    message,
    setMessage
}) => {
    const classes = styleCertificate();
    const [listDwonload, setListDwonload] = useState([]);
    const [idEmployee, setIdEmployee] = useState('');
    const [openModal, setOpenModal] = useState(false);

    const handleClickClose = () => {
        setMessage({...message, open:false});
    }

    const getValueByKey = (object, header) => {
        if (header.child === null) {
            if(header.field === 'name'){
                const name = `${data?.firstName ?? ''} ${data?.secondName ?? ''}`;
                return name;
            }
            if(header.field === 'surname'){
                const surname = `${data?.surname ?? ''} ${data?.secondSurname ?? ''}`;
                return surname;
            }
            if(header.field === 'documentType'){
                const findTypeDocument = maestras?.tipoDocumnetoIdentificacion?.find(x => x?.key === data?.documentType);
                return findTypeDocument?.value;
            }
            if(header.field === 'document'){
                return data?.document;
            }
            if(header.field === 'secondName'){
                return data?.secondName ?? '';
            }
            if(header.field === 'secondSurname'){
                return data?.secondSurname ?? '';
            }
            if(header.field === 'personalEmail'){
                return data?.personalEmail ?? '';
            }
            if(header.field === 'rol'){
                return '';
            }
            if(header.field === 'phone'){
                return data?.phone ?? '';
            }
            if(header.field === 'movil'){
                return data?.cellPhoneNumber ?? '';
            }
            if(header.field === 'gender'){
                return data?.gender ?? '';
            }
            if(header.field === 'creationDate'){
                return data?.creationDate ?? '';
            }
          if (header.field) {
            let result = "";
            if (header.field.includes(",")) {
              header.field.split(/\s*,\s*/).forEach(function (myString) {
                result += object[myString] + " ";
              });
              return result;
            }
            return object[header.field];
          }
          return "";
        }
        return object[header.field] !== null
          ? object[header.field][header.child]
          : "";
    };

    const messageError = (msj, type, action) => {
        setMessage({
            description: msj,
            textButtonSubmit: "Aceptar",
            handleClick: () => action(),
            type: type,
            oneButtons: true,
            open: true,
        });
    }

    const handleClickOpenDetail = (id) => {
        returnCertificate(id);
    }

    const returnCertificate = async (id) => {
        const response = await getCertificateId(id);
        if(response?.status === 200 || response?.status === 201){
            setListDwonload(response?.data);
        }else{
            setListDwonload([]);
            const msj = 'Ocurrió un error procesando la solicitud, inténtelo nuevamente';
            messageError(msj, 'WARNING', handleClickClose);
        }
    }

    const downloadFormat = async (id) => {
        const response = await downloadCertificate(id);
        if(response?.status === 200 || response?.status === 201){
            const pdf = response?.data?.data;
            downloadPDF(pdf, 'certificado laboral.pdf');
        }else{
            const msj = 'Ocurrió un error procesando la solicitud, inténtelo nuevamente';
            messageError(msj, 'WARNING', handleClickClose);
        }
    }

    const handleClickOpenModal = (info) => {
        setOpenModal(true);
        setIdEmployee(info?.id);
    }

    const closeModalCard = () => {
        setOpenModal(false);
        setIdEmployee('');
    }

  return (
    <div style={{marginTop: 10}}>
        <Accordion
            style={{borderLeftStyle: "solid", borderLeftColor: '#F8DF13'}}
        >
            <FlippedOrderExpansionPanelSummary
                aria-controls="panel1c-content"
                id={data?.id}
                expandIcon={<ExpandMoreIcon />}
                style={{ pointerEvents: "none" }}
            >
            {headers.initialHeaders.map((header) => (
                <div className={classes.column}>
                <Typography className={classes.heading}>
                    {header?.title}
                </Typography>
                <Typography className={classes.secondaryHeading}style={{flexBasis: 'auto', wordBreak: 'normal'}}>
                    {getValueByKey(data, header) }
                </Typography>
                </div>
            ))}
            
            <div className={classes.columnEvent}>
                <Tooltip title="Ver detalles" arrow placement="top">
                    <VisibilityIcon 
                        onClick={(e) => handleClickOpenDetail(data?.id)}
                        className={classes.iconEvent} 
                        style={{cursor: "pointer", pointerEvents: 'auto', marginRight: 15}}
                    />
                </Tooltip>
                <Tooltip title="Generar certificado laboral" arrow placement="top">
                    <CarnetIcon 
                        onClick={(e) => {e.stopPropagation(); handleClickOpenModal(data)}}
                        className={classes.iconEvent} 
                        style={{cursor: "pointer", pointerEvents: 'auto', marginRight: 15}}
                    />
                </Tooltip>
                
            </div>
            </FlippedOrderExpansionPanelSummary>
            <AccordionDetails className={classes.details}>
                <Grid container style={{width: '100%'}}>
                    {headers.othersHeaders.map((header) => (
                        <div className={classes.columnTwo}>
                            <Typography className={classes.heading}>
                                {header?.title}
                            </Typography>
                            <Typography className={classes.secondaryHeading}style={{flexBasis: 'auto', wordBreak: 'normal'}}>
                                {getValueByKey(data, header) }
                            </Typography>
                        </div>
                    ))}

                    {listDwonload?.length > 0
                        ?   listDwonload?.map((file) => {
                                const binding = maestras?.tiposDeVinculacionContratos.find(x => x.clave === file.bindingType);
                                const newFile = {...file, bindingType: binding?.valor}
                                return(
                                    <Grid container spacing={2} style={{marginTop: 10}}>
                                        <Grid item xs={12} md={3} lg={3}>
                                            <Typography className={classes.heading}>
                                                Tipo de certificado
                                            </Typography>
                                            <Typography className={classes.secondaryHeading}>
                                                {newFile?.bindingTypeDescription?.toLowerCase()}
                                            </Typography>
                                        </Grid>          
                                        <Grid item xs={12} md={3} lg={3}>
                                            <Typography className={classes.heading}>
                                                Fecha de creación
                                            </Typography>
                                            <Typography className={classes.heading}>
                                                {newFile?.creationDate ? moment(newFile?.creationDate).format('DD-MM-YYYY') : ''}
                                            </Typography>
                                        </Grid>          
                                        <Grid item xs={12} md={3} lg={3}>
                                            <Typography className={classes.heading}>
                                                <Link
                                                    underline="always"
                                                    style={{
                                                        color: "#4D8D9D",
                                                        fontWeight: "500",
                                                        cursor: "pointer",
                                                        pointerEvents: "auto",
                                                    }}
                                                    onClick={(e) => downloadFormat(file?.id)}
                                                    >
                                                    Descargar
                                                </Link>
                                            </Typography>
                                        </Grid>          
                                    </Grid>
                                )
                            })
                        :   null
                    }
                    
                </Grid>
            </AccordionDetails>
        </Accordion>

        <GenerateCertificate
            openCard={openModal}
            closeModalCard={closeModalCard}
            maestras={maestras}
            idEmployee={idEmployee}
            setMessage={setMessage}
            message={message}
            returnMessage={messageError}
            returnCertificate={returnCertificate}
            certicateId={data?.id}
        />
    </div>
  )
}

export default AccordionCertificate